import React from 'react';
import * as R from 'ramda';
import { bool, number, shape } from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';

const TwoPartyExchange = ({ exchange, selfType, m }) => {
  const theme = useTheme();
  const twoPartyStatusLabel = R.cond([
    [R.equals(true), R.always('Active')],
    [R.equals(false), R.always('Pending')],
    [R.equals(null || undefined), R.always('Inactive')],
  ]);

  const plain = exchange || selfType;
  return (
    <Box
      bgcolor={plain ? 'transparent' : 'graphic.lighter'}
      border={1}
      borderColor={plain ? theme.palette.graphic.light : 'transparent'}
      borderRadius="4px"
      h="61px"
      m={m}
      px={0.5}
      py={1}
      textAlign="center"
    >
      <Typography
        sx={{
          color: selfType ? 'text.secondary' : 'text.primary',
          mb: 1,
        }}
        variant="body2"
      >
        Two Party Exchange
      </Typography>
      <Typography sx={{ color: 'text.secondary' }} variant="body2">
        {selfType
          ? 'Unavailable for Self Authorizations'
          : twoPartyStatusLabel(exchange?.confirmed)}
      </Typography>
    </Box>
  );
};

export default TwoPartyExchange;

TwoPartyExchange.propTypes = {
  exchange: shape({
    confirmed: bool,
  }),
  m: number,
  selfType: bool,
};

TwoPartyExchange.defaultProps = {
  exchange: null,
  m: 1,
  selfType: false,
};
